import React from 'react';

const NotFound = () => {
  return <h1>Not found</h1>;
};

export default NotFound;
